import * as awdCustom from './functions.js';

let scrl;

document.addEventListener("DOMContentLoaded", function(){

	awdCustom.insertSocializeIcon()
	awdCustom.insertMapIcon()
	scrl = awdCustom.customScrollPage()

	if(!awdCustom.isAllMobileDevices){
		new awdCustom.mousePointer();
		awdCustom.introLoader(scrl).then(() => awdCustom.CanvasHome())
	}else{
		awdCustom.introLoader(scrl)
	}
	
	new awdCustom.Header(scrl);
	awdCustom.buttonsAnimation();
	awdCustom.arrowHome();
	awdCustom.footerFunctions();
	
});